import { Buffer } from "buffer";

const IconArrow = (color: string = "#fff") => {
  const svgData = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.789 16.522">
  <g id="グループ_5101" data-name="グループ 5101" transform="translate(-672.895 -1143.603)">
    <path id="パス_939" data-name="パス 939" d="M7613.481-13347.033h-6.087v12.017H7619.4v-6.944" transform="translate(-6934 14494.643)" fill="none" stroke="${color}" stroke-width="1"/>
    <path id="パス_940" data-name="パス 940" d="M7611.688-13339.447l9.372-9.137" transform="translate(-6932.289 14493.065)" fill="none" stroke="${color}" stroke-width="1"/>
    <path id="パス_941" data-name="パス 941" d="M7619.383-13351.535h6.232v6.1" transform="translate(-6936.431 14495.639)" fill="none" stroke="${color}" stroke-width="1"/>
  </g>
</svg>

    `;
  const base64 =
    "data:image/svg+xml;base64," + Buffer.from(svgData).toString("base64");
  return base64;
};

export default IconArrow;
